import SnapshotRating from './SnapshotRating';
import ReactTooltip from 'react-tooltip';
import React, { useContext } from 'react';
import { QueryUrls, SnapshotGalleryContext } from '../../contexts/SnapshotGalleryContext';
import _ from 'lodash';
import { connect } from 'react-redux';

const LightboxCaption = ({
  snapshot,
  favoriteSnapshots = [],
  favoriting,
  deleting,
  canSeeTrashIcon,
  onDelete,
  onFavorite,
  isAuthenticated,
}) => {
  const { queryType } = useContext(SnapshotGalleryContext);
  const isContest = queryType === QueryUrls.CONTEST;

  function openFile() {
    window.open(snapshot.snapshot, 'Image', 'width=1200,height=768,resizable=1');
  }

  const isFavorite = favoriteSnapshots.includes(snapshot.uuid);
  const activeClass = (isFavorite) ? 'fas favorited' : 'far';

  return (
    <div className="row">
      <div className="col">
        {snapshot.caption}
      </div>
      <div className="col col-auto" style={{ fontSize: '1.4em' }}>
        {!!isContest && <div className="d-inline-block pr-2" style={{ verticalAlign: 'top' }}>
          <SnapshotRating
            rating={parseFloat(snapshot.average_rating)}
            snapshotId={snapshot.uuid}
            isAuthenticated={isAuthenticated}
          />
        </div>}
        {deleting &&
          <i
            className="m-2 fa-spin fas fa-spinner no-outline"
            role="button"
            tabIndex={0}
          />}
        {canSeeTrashIcon && !deleting && (
          <span>
            <span
              className="m-2 clickable no-outline snapshot-admin-icon hover-red"
              onClick={onDelete}
              role="button"
              tabIndex={0}
              alt="Delete Snapshot"
              data-tip
              data-for="delete"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1 -32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1 -32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1 -32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.7 23.7 0 0 0 -21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0 -16-16z"
                />
              </svg>
            </span>
            <ReactTooltip
              id="delete"
              type="light"
              effect="solid"
            >
              Delete Snapshot
            </ReactTooltip>
            </span>
        )}

        {snapshot.recording_uri && (
          <span>
            <a
              className="text-white"
              href={snapshot.recording_uri}
              rel="noopener noreferrer"
              target="_blank"
              data-tip
              data-for="recording"
            >
              <span className="m-2 clickable snapshot-admin-icon hover-blue" role="button" tabIndex={0}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
                  />
                </svg>
              </span>
            </a>
            <ReactTooltip
              id="recording"
              type="light"
              effect="solid"
            >
              Download Recording
            </ReactTooltip>
            </span>
        )}

        {snapshot.youtube_id && (
          <span>
            <a
              className="text-white"
              href={`https://youtube.com/watch?v=${snapshot.youtube_id}&t=${snapshot.youtube_delta}`}
              rel="noopener noreferrer"
              target="_blank"
              data-tip
              data-for="highlight"
            >
              <span className="fab fa-youtube m-2 clickable hover-red" role="button" tabIndex={0}/>
            </a>
            <ReactTooltip
              id="highlight"
              type="light"
              effect="solid"
            >
              Watch Highlight
            </ReactTooltip>
            </span>
        )}

        <span
          className="snapshot-admin-icon m-2 clickable hover-blue"
          onClick={openFile}
          role="button"
          tabIndex={0}
          data-tip
          data-for="download"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
              d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
            />
          </svg>
        </span>
        <ReactTooltip
          id="download"
          type="light"
          effect="solid"
        >
          Download Snapshot
        </ReactTooltip>

        {favoriting.includes(snapshot.uuid) ? (
          <i
            className="m-2 fa-spin fas fa-spinner no-outline"
            role="button"
            tabIndex={0}
          />
        ) : (
          <span>
            <i
              className={`m-2 clickable no-outline fa-star favorite-heart ${activeClass}`}
              onClick={onFavorite}
              role="button"
              tabIndex={0}
              data-tip
              data-for="toggle-favorite"
            />
            <ReactTooltip
              id="toggle-favorite"
              type="light"
              effect="solid"
            >
              Toggle Favorite
            </ReactTooltip>
          </span>
        )}
      </div>
    </div>
  );
};

const mapStateToPops = (state) => {
  const { favorites, auth, currentUser } = state;
  return {
    favoriteSnapshots: _.get(favorites, 'user.snapshots', []) || [],
    currentUsername: _.get(auth, 'userName', null),
    currentUser: _.get(currentUser, 'data', {}),
    isAuthenticated: state.auth.isAuthenticated,
  };
};

export default connect(mapStateToPops)(LightboxCaption);
